import { useMemo } from 'react';
import { Power } from 'lucide-react';
import { useBoolean } from 'usehooks-ts';

import type { Site } from '@/api/fe-api/domain/entities/site';
import { Dialog, DialogBody, DialogTitle } from '@/components/ui/dialog';
import { useMe } from '@/hooks/use-me';
import { StatsBox } from '@/modules/documents/view/components/pages/site-overview/stats-box';

import { ButtonDownload } from './button-download';
import { TableTrippedSystems } from './table-tripped-sytems';

export type CardTrippedSystemProps = {
  site: Site;
  className?: string;
};

export function CardTrippedSystem({ site, className }: CardTrippedSystemProps) {
  const me = useMe();
  const isShowDialog = useBoolean();

  const color = useMemo(() => {
    return site.unitStatus.operational > 0
      ? site.unitStatus.tripped.length > 0
        ? 'yellow'
        : 'green'
      : 'neutral';
  }, [site.unitStatus.operational, site.unitStatus.tripped.length]);

  return (
    <>
      <StatsBox
        className={className}
        icon={{
          color: color,
          element: <Power />,
        }}
        title={
          me.whiteLabel
            ? 'Inverters (Online / Offline)'
            : 'In Operation / Tripped'
        }
        value={
          me.whiteLabel
            ? '31 / 0'
            : `${site.unitStatus.operational} / ${site.unitStatus.tripped.length}`
        }
      >
        <StatsBox.Action>
          {site.unitStatus.tripped.length > 0 ? (
            <button onClick={() => isShowDialog.setTrue()}>View List</button>
          ) : null}
        </StatsBox.Action>
      </StatsBox>
      <Dialog
        open={isShowDialog.value}
        onClose={isShowDialog.setFalse}
        className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
      >
        <DialogTitle className="flex items-baseline justify-between">
          <span>In Operation / Tripped</span>
          <ButtonDownload site={site} />
        </DialogTitle>
        <DialogBody className="max-h-[80vh] overflow-y-auto overflow-x-hidden">
          <TableTrippedSystems site={site} />
        </DialogBody>
      </Dialog>
    </>
  );
}
